import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import { tableHeaderSx } from '../../styles/tokens';

const SortableTableHeader = ({
  label,
  column,
  sortBy,
  sortDir,
  onSort,
  align = 'left',
  width,
  minWidth,
}) => (
  <TableCell
    align={align}
    sx={{
      ...tableHeaderSx,
      ...(width && { width }),
      ...(minWidth && { minWidth }),
      cursor: 'pointer',
      userSelect: 'none',
    }}
  >
    <TableSortLabel
      active={sortBy === column}
      direction={sortBy === column ? sortDir : 'asc'}
      onClick={() => onSort(column)}
      sx={{
        '& .MuiTableSortLabel-icon': {
          opacity: sortBy === column ? 1 : 0.35,
        },
      }}
    >
      {label}
    </TableSortLabel>
  </TableCell>
);

export default SortableTableHeader;
